import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "layout flexRow" };
const _hoisted_2 = { class: "pgFlex flexColumn layout_main" };
const _hoisted_3 = {
    class: "main pgFlex flexColumn",
    style: { "height": "calc(100% - 22px)" }
};
const _hoisted_4 = {
    class: "flexRow-alc flex-jcc ft12",
    style: { "padding-bottom": "4px", "color": "#ccc", "background": "#fff" }
};
const _hoisted_5 = { key: 0 };
import { onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const store = useStore();
        onMounted(() => {
        });
        onUnmounted(() => {
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_Transition, { name: "el-fade-in" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_router_view)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        (!_unref(store).state.hideBottomTips)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "内容由AI生成，仅供参考"))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
